var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root room-closed-chat-message",class:{ own: _vm.isOwn }},[_c('div',{staticClass:"message-container"},[_c('div',[_vm._v(_vm._s(_vm.msgFirst))]),_c('div',[_vm._v(_vm._s(_vm.msgSecond))])])])}
var staticRenderFns = []

export { render, staticRenderFns }